<template>
    <Modal small ref="modal" qa-name="installments-agreement-modal" @modal-closed="cleanUp" @modal-opened="enforceScroll">
        <h2 class="font-bold text-center font-walsheim text-2xl mb-8 leading-none">Installment Agreement</h2>
        <div class="overflow-y-scroll max-h-[500px] p-4 bg-gray-6 rounded-large scrollbar space-y-8" ref="scrollContainer">
            <p class="text-sm">
                <b>Annual Commitment:</b> In exchange for your commitment to Keap for 12-Months, Keap agrees to offer the Annual subscription at the prices shown here and described in the payment schedule below.
            </p>
            <p class="text-sm">
                <b>Annual Term:</b> Your annual term will begin on the date you return this signed agreement and your payment information to Keap, or if you were already a Keap customer, on your next billing date thereafter.
            </p>
            <p class="text-sm">
                <b>Automatic Renewal:</b> At the end of the 12-Month term under this agreement, your subscription will automatically renew for additional annual terms pre-paid in full at Keap’s then-current pricing for the services you are using until you cancel your subscription, or your subscription is otherwise terminated.
            </p>
            <p class="text-sm">
                All Keap plans include 1-year of Keap Text & Voice at no charge. Upon renewal, Keap customers will be charged for Keap Text & Voice at the current price of Keap Text & Voice.
            </p>
            <p class="text-sm">
                <b>Payment:</b> For the above purchases, you authorize Keap to charge your account’s primary credit card for the full amount of your purchase and for future purchases during your subscription period. If you should fail to make payment when due, Keap may declare the remaining unpaid amount as immediately due and payable. Payments are non-refundable.
            </p>
            <p class="text-sm">
                <b>Additional Terms:</b> Applicable taxes will be included when billed. All prices are payable in USD. Your purchase is subject to the standard terms set forth at <a href="https://www.keap.com/legal" target="_blank" rel="noopener" class="underline">https://www.keap.com/legal</a>, except as otherwise provided in this document.
            </p>
        </div>
‭
        <div class="flex flex-col items-center space-y-3 justify-center">
            <CheckBox
                key="installmentAgreement"
                v-model="installmentAgreement"
                data-qa="installments-checkbox"
                :valid="installmentAgreement"
                field-type="text"
                error-message="You must accept the terms to continue"
                required
                :disabled="!hasScrolled"
                @disabled-click="showHelper = true"
            >
                <template v-slot:label>
                    <p class="text-2xs" data-qa="tc-label">Click here to indicate that you have read and agree to Keap’s terms</p>
                </template>
                <template v-slot:error>
                    <p class="text-2xs" data-qa="tc-label">
                        Please read all the terms and conditions by scrolling to the bottom before accepting.
                    </p>
                </template>
            </CheckBox>
        </div>
    </Modal>
</template>

<script>

import Modal from '@/Components/Modal.vue';
import Link from '@/Components/Link.vue';
import CheckBox from '@/BuyNow/Components/inputs/CheckBox.vue';

export default {
    components: {
        Modal,
        Link,
        CheckBox,
    },
    props: {
        noClose: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            hasScrolled: false,
            showHelper: false,
            installmentAgreement: false,
        }
    },
    expose: [
        'openModal',
    ],
    emits: [
        'agreementAccepted',
    ],
    computed: {
        installmentAgreement: {
            get() {
                return this.$store.getters.cartInfo.acceptedInstallments;
            },
            async set(value) {
                if (!this.hasScrolled) {
                    console.log('showHelper', this.hasScrolled);
                    this.showHelper = true;
                    this.$store.getters.cartInfo.acceptedInstallments = false;
                } else {
                    this.$store.commit('updateCartInfo', { acceptedInstallments: value });
                    await setTimeout(() => {
                        this.$refs.modal.closeModal();
                    }, 500);
                }
            }
        }
    },
    methods: {
        cleanUp() {
            this.hasScrolled = false;
            this.$emit('agreementAccepted', this.$store.getters.cartInfo.acceptedInstallments);
            this.$refs.scrollContainer.removeEventListener('scroll', this.checkScroll);
        },
        enforceScroll() {
            this.$nextTick(() => {
                this.$refs.scrollContainer.addEventListener('scroll', this.checkScroll);
            });
        },
        openModal() {
            this.$refs.modal.openModal();
        },
        checkScroll() {
            const container = this.$refs.scrollContainer;
            if (container.scrollTop + container.clientHeight >= container.scrollHeight) {
                this.hasScrolled = true;
            }
        },
    },
    watch: {
    }
};
</script>

<style lang="scss" scoped>
</style>
